import { c as _c } from "react/compiler-runtime";
import { IcoRotate16 } from '@onefootprint/icons';
import type { BBox } from '@onefootprint/request-types/dashboard';
import { IconButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import Image from 'next/image';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRotation from '@/hooks/use-rotation';
import { isSideways, ROTATION_CLASS_NAME } from '@/utils/rotation';
import BoundingBoxOverlay from '../bounding-box-overlay';
type BboxWithId = {
  id: string;
  bbox: BBox;
  pageId?: number;
};
type ImageViewerProps = {
  src: string;
  bboxes: BboxWithId[];
  selectedBboxIds: Set<string>;
  onBboxClick: (id: string, pageId?: number) => void;
};
const ImageViewer = t0 => {
  const $ = _c(25);
  const {
    src,
    bboxes,
    selectedBboxIds,
    onBboxClick
  } = t0;
  const {
    t
  } = useTranslation("document-viewer");
  const [imageDimensions, setImageDimensions] = useState(null);
  const {
    rotation,
    rotate
  } = useRotation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      const img = event.currentTarget;
      setImageDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleImageLoad = t1;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== rotate || $[4] !== t2) {
    t3 = <div className="flex items-center justify-end px-3 py-2 border-b border-tertiary bg-secondary shrink-0 rounded-t-lg"><IconButton aria-label={t2} icon={IcoRotate16} onClick={rotate} variant="ghost" size="compact" /></div>;
    $[3] = rotate;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = ROTATION_CLASS_NAME[rotation];
  let t5;
  if ($[6] !== t4) {
    t5 = cx("relative inline-block bg-white rounded-lg shadow-lg overflow-hidden", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== rotation) {
    t6 = cx("object-contain w-auto h-auto", {
      "max-w-[100cqh] max-h-[100cqw]": isSideways(rotation),
      "max-w-[100cqw] max-h-[100cqh]": !isSideways(rotation)
    });
    $[8] = rotation;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== src || $[11] !== t6) {
    t7 = <Image src={src} alt="Document" width={0} height={0} sizes="100vw" className={t6} onLoad={handleImageLoad} unoptimized={true} />;
    $[10] = src;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== bboxes || $[14] !== imageDimensions || $[15] !== onBboxClick || $[16] !== selectedBboxIds) {
    t8 = imageDimensions && <BoundingBoxOverlay bboxes={bboxes} selectedBboxIds={selectedBboxIds} onBboxClick={onBboxClick} documentWidth={imageDimensions.width} documentHeight={imageDimensions.height} />;
    $[13] = bboxes;
    $[14] = imageDimensions;
    $[15] = onBboxClick;
    $[16] = selectedBboxIds;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className="[container-type:size] flex flex-1 min-h-0 items-center justify-center overflow-hidden p-4"><div className={t5}>{t7}{t8}</div></div>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t3 || $[23] !== t9) {
    t10 = <div className="flex flex-col w-full h-full border border-tertiary rounded-lg">{t3}{t9}</div>;
    $[22] = t3;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default ImageViewer;
function _temp($) {
  return $.header.rotate;
}